<template lang="pug">
v-card.custom-card(outlined, :style="estiloCard")
  v-progress-linear.arvore-loading-bar(
    v-if="carregando",
    indeterminate,
    color="blue",
    height="2"
  )

  .d-flex.align-center.justify-space-between.gap-2.arvore-header
    .arvore-title {{ titulo }}
    v-spacer
    v-btn.btn-action.text-none(
      v-if="mostrarExpandirRecolher",
      outlined,
      small,
      :disabled="!itens.length",
      @click="$emit('expandir')"
    ) {{ textoExpandir }}
    v-btn.btn-action.text-none(
      v-if="mostrarExpandirRecolher",
      outlined,
      small,
      :disabled="!itens.length",
      @click="$emit('recolher')"
    ) {{ textoRecolher }}
  v-divider
  .tree-content.pa-0(v-if="!carregando")
    //- Estado vazio: pré-requisito não atendido (ex.: nenhuma empresa selecionada)
    .tree-empty.justify-center.align-center.text-center.py-8(v-if="!habilitado")
      v-icon.empty-state-icon(size="48", color="blue lighten-3") {{ iconeSemSelecao }}
      .empty-state-subtitle.mt-2 {{ textoSemSelecao }}

    //- Estado vazio: nenhum item encontrado
    .tree-empty.justify-center.align-center.text-center.py-8(v-else-if="!itens.length")
      v-icon.empty-state-icon(size="48", color="blue lighten-3") mdi-file-tree-outline
      .empty-state-subtitle.mt-2 {{ textoVazio }}

    //- Estado normal
    div(v-else)
      .consulta-search.pa-3(v-if="comBusca")
        v-text-field.preview-field(
          :value="filtro",
          @input="$emit('update:filtro', $event)",
          prepend-inner-icon="mdi-magnify",
          :placeholder="placeholderBusca",
          clearable,
          hide-details,
          filled,
          rounded,
          dense
        )
      .treeview-scroll-wrapper(
        :style="estiloScroll",
        :class="{ 'treeview-checkboxes--disabled': checkboxesDesabilitados }"
      )
        v-treeview.treeview-custom(
          :class="{ 'treeview-custom--rotulos': estiloRotulos }",
          :key="treeKey",
          :items="itens",
          :active="active",
          @update:active="$emit('update:active', $event)",
          :open="open",
          @update:open="$emit('update:open', $event)",
          :value="selected",
          @input="$emit('update:selected', $event)",
          :search="comBusca ? filtro : undefined",
          selected-color="grey",
          :selectable="selectable",
          activatable,
          hoverable,
          dense,
          :item-id="itemId",
          :item-text="itemText",
          :item-children="itemChildren"
        )
          template(v-slot:label="{ item }")
            slot(name="label", :item="item")
</template>

<script>
export default {
  name: "ArvoreCard",

  props: {
    titulo: {
      type: String,
      default: "Árvore"
    },
    itens: {
      type: Array,
      default: () => []
    },
    carregando: {
      type: Boolean,
      default: false
    },
    habilitado: {
      type: Boolean,
      default: true
    },
    altura: {
      type: String,
      default: ""
    },
    alturaInterna: {
      type: String,
      default: ""
    },
    open: {
      type: Array,
      default: () => []
    },
    active: {
      type: Array,
      default: () => []
    },
    selected: {
      type: Array,
      default: () => []
    },
    selectable: {
      type: Boolean,
      default: false
    },
    checkboxesDesabilitados: {
      type: Boolean,
      default: false
    },
    comBusca: {
      type: Boolean,
      default: false
    },
    mostrarExpandirRecolher: {
      type: Boolean,
      default: true
    },
    filtro: {
      type: String,
      default: ""
    },
    placeholderBusca: {
      type: String,
      default: "Pesquisar na árvore..."
    },
    treeKey: {
      type: String,
      default: undefined
    },
    itemId: {
      type: String,
      default: "id"
    },
    itemText: {
      type: String,
      default: "text"
    },
    itemChildren: {
      type: String,
      default: "menusFilhos"
    },
    iconeSemSelecao: {
      type: String,
      default: "mdi-domain"
    },
    textoSemSelecao: {
      type: String,
      default: "Selecione uma empresa para visualizar a árvore"
    },
    textoVazio: {
      type: String,
      default: "Nenhum item encontrado"
    },
    textoExpandir: {
      type: String,
      default: "Expandir"
    },
    textoRecolher: {
      type: String,
      default: "Recolher"
    },
    estiloRotulos: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    // Sem altura explícita o card preenche o espaço do container flex.
    estiloCard() {
      const estilo = { position: "relative" };
      if (this.altura) estilo.height = this.altura;
      return estilo;
    },

    estiloScroll() {
      return this.alturaInterna ? { maxHeight: this.alturaInterna } : {};
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.btn-action {
  height: 30px !important;
  min-width: 0 !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  border: 1px solid #d0d7de !important;
  color: #57606a !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.text-none {
  text-transform: none !important;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input,
.preview-field .v-select__selection {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__slot {
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.preview-field .v-label {
  color: #8a94a3;
  font-size: 13px;
}

.arvore-header {
  flex: 0 0 auto;
  min-height: 56px;
  padding: 0 18px;
  display: flex;
  align-items: center;
}

.gap-2 {
  gap: 8px;
}

.arvore-title {
  color: #0f2b57;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.tree-content {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.tree-content > div {
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1 1 auto;
}

.consulta-search {
  flex: 0 0 auto;
}

.tree-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}

.treeview-scroll-wrapper {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 0 8px;
}

/* ===== V-Treeview Styles ===== */
.treeview-custom {
  font-size: 14px;
}

.treeview-custom .v-treeview-node__root {
  padding: 4px 8px;
}

.treeview-custom .v-treeview-node__root:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

.treeview-custom .v-treeview-node--active > .v-treeview-node__root {
  background-color: rgba(25, 118, 210, 0.12);
}

.treeview-custom .v-treeview-node__content {
  display: flex;
  align-items: center;
  gap: 4px;
}

.treeview-custom .v-treeview-node__label {
  flex: 1;
  font-size: 14px;
}

.treeview-custom--rotulos ::v-deep .tree-label-text {
  font-size: 14px;
  color: #2c3e50;
}

.treeview-custom--rotulos ::v-deep .tree-label--group {
  font-weight: 600;
  color: #1976d2;
}

.treeview-custom--rotulos ::v-deep .sistema-executavel {
  font-size: 11px;
  color: #8a94a3;
}

.treeview-custom .v-treeview-node__toggle {
  color: #757575;
}

.treeview-custom .v-treeview-node__checkbox {
  color: #757575;
}

.treeview-custom .v-treeview-node__level {
  width: 16px;
}

.treeview-checkboxes--disabled .v-treeview-node__checkbox {
  opacity: 0.4;
  pointer-events: none !important;
  cursor: default !important;
}

.treeview-checkboxes--disabled .v-treeview-node__checkbox *,
.treeview-checkboxes--disabled .v-simple-checkbox,
.treeview-checkboxes--disabled .v-simple-checkbox * {
  pointer-events: none !important;
  cursor: default !important;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}

.arvore-loading-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1;
  border-radius: 4px 4px 0 0;
}
</style>
